module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/cup-3ccd6b23a3652a720f711baa4c221fe4.png";